import * as React from "react";
import { UitkText, UitkTextProps } from "uitk-react-text";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";

interface ConfidenceMsgGridItemProps {
  id: string;
  text: { __html: string };
  weight?: UitkTextProps["weight"];
  boxType?: string;
}

export const ConfidenceMsgGridItem: React.FC<ConfidenceMsgGridItemProps> = ({ id, text, weight, boxType }) => {
  const useUitkCard = boxType === "blossom-white";

  if (!text || !text.__html) {
    return null;
  }

  const mainContent = (
    <UitkText align="center" weight={weight} size={500}>
      <div data-fm-content={id} dangerouslySetInnerHTML={text} />
    </UitkText>
  );

  return useUitkCard ? (
    <UitkCard>
      <UitkCardContentSection>{mainContent}</UitkCardContentSection>
    </UitkCard>
  ) : (
    mainContent
  );
};
